import React from 'react'
import { useScreensaverContent } from '../../hook/useScreensaverContent'
import MediaCarousel from '../MediaCarousel'
import FallbackLogo from '../FallbackLogo'
import Loading from 'Components/Loading'
import './mediaScreensaver.css'

export default function MediaScreensaver() {
  const { content, loading, error } = useScreensaverContent()

  if (loading) {
    return <Loading full />
  }

  // If error or no content, show fallback logo
  if (error || content.length === 0) {
    return <FallbackLogo />
  }

  return (
    <div className="media-screensaver" data-testid="media-screensaver">
      <MediaCarousel content={content} />
    </div>
  )
}
